import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { Line } from 'react-chartjs-2';
import 'tailwindcss/tailwind.css';
import api from '../../api/api';
import Loading from './loading';
import {Bell, ChartNoAxesCombined, ShoppingBag} from 'lucide-react';
import { Select, SelectItem, Tab, Tabs } from '@heroui/react';
import { useDataContext } from '../../context/data';

const OrderGraph = () => {
  const [period, setPeriod] = useState('week'); // "month" pour l'agrégation quotidienne
  const [graphData, setGraphData] = useState(null);
  const chartRef = useRef(null);
  const {theme} = useDataContext()
  useEffect(() => {

    const fetchDetails = async () => {

      try {

        setGraphData(null)

        const data = await api.order.getGraphData(period);
        
        // On formate les labels selon la période sélectionnée
        const labels = data.map((d) => {
          if (period === 'week') {
            return d.period; // Par exemple "Week 1", "Week 2", etc.
          } else if (period === 'year') {
            // Formater en nom de mois
            const date = new Date(d.period);
            return date.toLocaleString('default', { month: 'long' });
          } else if (period === 'month') {
            // Pour l'agrégation quotidienne, on affiche le numéro du jour
            const date = new Date(d.period);
            return date.getDate().toString();
          }
          return d.period;
        });
        
        const counts = data.map((d) => parseInt(d.count, 10));
        
        setGraphData({
          labels,
          datasets: [
            {
              label: 'Nombre de commandes',
              data: counts,
              fill: true,
              borderColor: '#009018',
              tension: 0.4,
            },
          ],
        });

        console.log(graphData)

      } catch (error) {
        console.error('Erreur lors de la récupération des données', error);
      }
    };

    fetchDetails();

  }, [period]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          color: theme === 'dark' ? '#ffffff' : '#000000',
        },
      },
      title: {
        display: true,
        text: 'Statistiques',
        color: theme === 'dark' ? '#ffffff' : '#000000',
      },
    },
    scales: {
      x: {
        ticks: {
          color: theme === 'dark' ? '#ffffff' : '#000000',
        },
        grid: {
          color: theme === 'dark' ? '#444' : '#ccc',
        },
      },
      y: {
        ticks: {
          color: theme === 'dark' ? '#ffffff' : '#000000',
        },
        grid: {
          color: theme === 'dark' ? '#444' : '#ccc',
        },
      },
    },

    layout: {
      padding: 10,
    },

    backgroundColor: theme === 'dark' ? '#000' : '#000'
  };

  return (
    <div className="p-4">

      <div className="mb-4 flex gap-10 items-center justify-between dark:text-gray-100">

        <Tabs aria-label="Tabs sizes" size={'sm'} color={'primary'} selectedKey={period} onSelectionChange={setPeriod}>
          <Tab key={'week'} title="Semaines"/>
          <Tab key={'year'} title="Année" />
        </Tabs>
        <div className="flex items-center space-x-2">
          <h3 className="text-lg font-semibold">Ventes</h3>
          <ShoppingBag size={20} className="text-gray-500" />
        </div>

      </div>

      {graphData ? (<motion.div
        className="bg-white p-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Line data={graphData} redraw ref={chartRef} />
      </motion.div>) : (<Loading icon={<ChartNoAxesCombined color="primary" size={18} />} />)}
    </div>
  )
};

export default OrderGraph;
